export enum TourKind {
  TOUR = 'Tour',

  ACTIVITY = 'Activity',

  EVENT = 'Event',

  OTHER = 'Other',
}
